// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/sources/ConfiguredItemForm.scss
// module id = 556
// module chunks = 0